import reviewReducer from "./review_reducer"

export default reviewReducer;